import { useState, useEffect, useRef } from 'react';
import './TapGame.css';

const CDN_TAP = 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/tap_game';
const PHOTO_SETS = ['1st', '2nd', '3rd', '4th', '5th'];
const SET_STORAGE_KEY = 'tapGameSetIdx';

function getNextPhotoSet() {
  let idx = 0;
  try {
    const stored = parseInt(localStorage.getItem(SET_STORAGE_KEY) ?? '-1', 10);
    idx = (isNaN(stored) ? -1 : stored) + 1;
    if (idx >= PHOTO_SETS.length) idx = 0;
    localStorage.setItem(SET_STORAGE_KEY, String(idx));
  } catch {}
  const folder = PHOTO_SETS[idx];
  return Array.from({ length: 8 }, (_, i) => `${CDN_TAP}/${folder}/${i}.webp`);
}

const HYPE_MESSAGES = [
  "Tap to undress her",
  "She wants more",
  "Don't stop now",
  "She's warming up",
  "Getting closer",
  "You're doing great",
  "Almost there",
  "She's almost ready",
  "Just a bit more",
  "So close to the prize",
];

const FLOATER_EMOJIS = ['🔥', '💋', '💦', '😏', '💫', '✨'];

export function TapGame({ photos: photosProp, isVideo = false, durationMs = 80000, onDone, noScroll = false }) {
  const photosRef = useRef(photosProp || getNextPhotoSet());
  const photos = photosRef.current;
  const totalTaps = Math.max(photos.length, Math.round(durationMs / 500));
  const tapsPerPhoto = Math.ceil(totalTaps / photos.length);

  const [taps, setTaps] = useState(0);
  const [floaters, setFloaters] = useState([]);
  const [shaking, setShaking] = useState(false);
  const floaterId = useRef(0);
  const shakeTimer = useRef(null);
  const wrapRef = useRef(null);

  const done = taps >= totalTaps;
  const idx = Math.min(photos.length - 1, Math.floor(taps / tapsPerPhoto));
  const photoProgress = done ? 1 : (taps % tapsPerPhoto) / tapsPerPhoto;
  const totalProgress = Math.min(1, taps / totalTaps);

  const messageIdx = Math.min(
    HYPE_MESSAGES.length - 1,
    Math.floor(totalProgress * HYPE_MESSAGES.length)
  );

  useEffect(() => {
    photos.forEach(src => { const img = new Image(); img.src = src; });
  }, [photos]);

  const handleTap = (e) => {
    if (done) return;
    setTaps(t => {
      const next = Math.min(totalTaps, t + 1);
      if (t === 0 && !noScroll) {
        wrapRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (next >= totalTaps) {
        onDone?.();
      }
      return next;
    });

    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const id = floaterId.current++;
    const emoji = FLOATER_EMOJIS[Math.floor(Math.random() * FLOATER_EMOJIS.length)];
    const drift = (Math.random() - 0.5) * 60;
    setFloaters(f => [...f, { id, x, y, emoji, drift }]);
    setTimeout(() => {
      setFloaters(f => f.filter(fl => fl.id !== id));
    }, 900);

    setShaking(false);
    requestAnimationFrame(() => setShaking(true));
    if (shakeTimer.current) clearTimeout(shakeTimer.current);
    shakeTimer.current = setTimeout(() => setShaking(false), 200);
  };

  return (
    <div className="tapGameWrap" ref={wrapRef}>
      <div className="tapGameTitle" key={messageIdx}>{HYPE_MESSAGES[messageIdx]}</div>

      <div className="tapGameProgress">
        {photos.map((_, i) => {
          let fill = 0;
          if (i < idx) fill = 1;
          else if (i === idx) fill = photoProgress;
          return (
            <div key={i} className="tapGameDot">
              <div className="tapGameDotFill" style={{ width: `${fill * 100}%` }} />
            </div>
          );
        })}
      </div>

      <div
        className={`tapGameImgWrap ${shaking ? 'tapGameImgWrap--shake' : ''}`}
        onClick={handleTap}
        style={{ '--glow': 0.15 + totalProgress * 0.5 }}
      >
        <img
          key={idx}
          className="tapGameImg"
          src={photos[idx]}
          alt=""
          draggable={false}
        />
        <div className="tapGameShine" />
        {!done && (
          <div className="tapGameTapBadge">
            <span>👆</span> Keep tapping!
          </div>
        )}
        {done && (
          <div className="tapGameDoneBadge">
            <span>✨</span> Nice!
          </div>
        )}
        {floaters.map(f => (
          <div
            key={f.id}
            className="tapGameFloater"
            style={{ left: f.x, top: f.y, '--drift': `${f.drift}px` }}
          >
            {f.emoji}
          </div>
        ))}
      </div>

    </div>
  );
}
